import styled from '@emotion/styled';

export const App = styled.div`
  height: 100%;
`;
